import axios from "axios";
import Config from "../utils/Config";

const BASE_URL = `${Config.apiUrl}`;

class PaymentService {
  getAuthHeaders() {
    return {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    };
  }

  async processPayment(payload) {
    try {
      const response = await axios.post(
        `${BASE_URL}/user/payment/process`,
        payload,
        this.getAuthHeaders()
      );
      return {
        status: true,
        data: response.data,
        message: response.data.message || "Payment processed successfully",
      };
    } catch (error) {
      return {
        status: false,
        data: null,
        message: error.response?.data?.message || "Payment processing failed",
      };
    }
  }

  async verifyPayment(registrationId) {
    try {
      const response = await axios.get(
        `${BASE_URL}/user/payment/verify/${registrationId}`,
        this.getAuthHeaders()
      );
      return {
        status: true,
        data: response.data,
        message: response.data.message || "Payment verified successfully",
      };
    } catch (error) {
      return {
        status: false,
        data: null,
        message: error.response?.data?.message || "Payment verification failed",
      };
    }
  }

  /**
   * Verify a payment using a Paystack/gateway reference number.
   * Falls back to the same endpoint — the backend resolves by reference or registration ID.
   */
  async verifyByReference(reference) {
    try {
      const response = await axios.get(
        `${BASE_URL}/user/payment/verify/${reference}`,
        this.getAuthHeaders()
      );
      return {
        status: true,
        data: response.data,
        message: response.data.message || "Payment verified successfully",
      };
    } catch (error) {
      return {
        status: false,
        data: null,
        message: error.response?.data?.message || "Payment verification failed",
      };
    }
  }

  /**
   * Persist payment context to sessionStorage before redirecting to a
   * payment gateway. The /payment/success and /payment/failed pages read
   * this to show type-specific UI.
   *
   * @param {Object} ctx - Payment context object. Shape:
   *   {
   *     type: "insurance" | "event" | "conference" | "quote",
   *     subtype: string,          // e.g. "daily_commuter"
   *     policyType: string,
   *     providerName: string,
   *     coverLabel: string,
   *     amount: number|string,
   *     duration: string,
   *     eventTitle: string,
   *     slug: string,
   *     applicationId: string,
   *     registrationId: string,
   *     bookingId: string,
   *     ticketType: string,
   *     quantity: number,
   *     totalAmount: number|string,
   *     selectedTicket: object,
   *     returnPath: string,       // path to retry payment on failure
   *     reference: string,        // filled after gateway initiates
   *   }
   */
  storePaymentContext(ctx) {
    try {
      sessionStorage.setItem(
        "tripsecure_payment_context",
        JSON.stringify({ ...ctx, storedAt: Date.now() })
      );
    } catch (_) {}
  }

  /** Read and optionally clear the stored payment context. */
  readPaymentContext(clear = false) {
    try {
      const raw = sessionStorage.getItem("tripsecure_payment_context");
      if (!raw) return null;
      const ctx = JSON.parse(raw);
      if (clear) sessionStorage.removeItem("tripsecure_payment_context");
      return ctx;
    } catch (_) {
      return null;
    }
  }
}

const paymentService = new PaymentService();
export default paymentService;

